module.exports = __webpack_public_path__ + "media/images/icons/material/check-3f5ce35e5cc7dd0d39445b15d560f613.svg";